import React, { useContext } from "react";
import Box, { BoxProps } from "@material-ui/core/Box";
import GalleryContext from "../../../contexts/GalleryContext";
import GalleryButton from "./GalleryButton";
import CustomContextMenu from "../../Menu/CustomContextMenu";

export interface GalleryUploadButtonProps extends BoxProps {
  hideIfNonEmpty?: boolean;
  label?: string;
}

function GalleryUploadButton(props: GalleryUploadButtonProps) {
  const { hideIfNonEmpty, label, ...PropsForBox } = props;
  const { flags, files, setAttachmentDialogOpen } = useContext(GalleryContext);
  if (files.length > 0 && hideIfNonEmpty) {
    return null;
  }
  const buttonAttrs: { icon: "UPLOAD" | "ADD"; text: string } = {
    icon: flags && flags.length > 0 ? "UPLOAD" : "ADD",
    text: label || (flags && flags.length > 0 ? "Add Attachment" : "Add Picture or Document"),
  };
  if (flags && flags.length > 1) {
    return (
      <Box {...PropsForBox}>
        <CustomContextMenu
          buttonContent={(handleClick) => <GalleryButton {...buttonAttrs} onClick={handleClick} />}
          data={flags.map((s) => ({
            id: s.key,
            label: s.label,
          }))}
          onMenuItemClick={(x) =>
            setAttachmentDialogOpen({
              flag: flags?.filter((t) => t.key === x.id).pop(),
            })
          }
        />
      </Box>
    );
  }
  return (
    <Box {...PropsForBox}>
      <GalleryButton
        {...buttonAttrs}
        onClick={() =>
          setAttachmentDialogOpen({
            flag: flags?.[0],
          })
        }
      />
    </Box>
  );
}

export default GalleryUploadButton;
